import React from 'react';
import MyAccountSVGIcon from '@/public/images/ackodrive/myAccount.svg';
import { authenticationService } from '@/services/authentication_service';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { getLoginUrl } from 'utils/getLoginUrl';

export default function ProfileMobile({
    toggleProfileOptions,
    refid,
}: {
    toggleProfileOptions: any;
    refid: any;
}) {
    const router = useRouter();

    const handleMyAccountClick = () => {
        if (authenticationService.isLoggedIn()) {
            // eventTracker.pushEvent(
            //     'tap_btn_my_profile_options',
            //     EventType.TRACK_EVENT
            // );
            toggleProfileOptions();
        } else {
            window.location.href = getLoginUrl(router.asPath);
        }
    };
    return (
        <MyAccountWrapper id={refid} onClick={handleMyAccountClick}>
            <MyAccountSVGIcon />
        </MyAccountWrapper>
    );
}
export const MyAccountWrapper = styled.div``;
